var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoorParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48394 14.5969C3.48394 14.5969 2 15.8941 2 16.6367C2 17.3792 2 18.1206 2 18.1206M3.48394 14.5969L3.66943 13.9662M3.48394 14.5969H12.0162M12.0162 14.5969C12.0162 14.5969 13.5 15.8941 13.5 16.6367C13.5 17.3792 13.5 18.1206 13.5 18.1206M12.0162 14.5969L11.8678 13.9662M13.5 18.1206C13.5 18.1206 13.5 18.3055 13.5 19.0481C13.5 19.7906 12.9228 20.5 12.0162 20.5C11.0162 20.5 10.5 19.79 10.5 19.0481C10.5 18.3061 10.5 18.12 10.5 18.12M13.5 18.1206L10.5 18.12M2 18.1206C2 18.1206 2 18.491 2 19.0481C2 19.6051 2.5 20.5 3.5 20.5C4.5 20.5 5 19.5571 5 19C5 18.4429 5 18.1206 5 18.1206M2 18.1206H5M2.37097 13.6694L3.66943 13.9662M3.66943 13.9662C3.66943 13.9662 3.85484 12 4.59677 12C5.33871 12 10.2027 12 10.9032 12C11.6038 12 11.8678 13.9662 11.8678 13.9662M13.129 13.6694L11.8678 13.9662M5 18.1206L10.5 18.12",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.75V20.5H18.75V10.75H20C20.9665 10.75 21.75 9.9665 21.75 9V5C21.75 4.0335 20.9665 3.25 20 3.25H16C15.0335 3.25 14.25 4.0335 14.25 5V9C14.25 9.9665 15.0335 10.75 16 10.75H17.25Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9V7M17 7V5H17.9796C18.5918 5 19 5.11321 19 6.01887C19 6.92453 18.4694 7 17.9796 7H17Z",
    stroke: "#BF9A6D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorParking);
export default __webpack_public_path__ + "static/media/outdoor_parking.1db472ab7cbab72db5aea2b40c9d1858.svg";
export { ForwardRef as ReactComponent };